"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const NavigationWrapperWeb_1 = __importDefault(require("./NavigationWrapperWeb"));
const react_i18next_1 = require("react-i18next");
const InputWeb_1 = __importDefault(require("./InputWeb"));
const react_1 = require("react");
const helper_1 = require("../../services/helper");
const native_1 = require("@react-navigation/native");
const authHandlers_1 = require("../../handlers/authHandlers");
const ButtonWeb_1 = __importDefault(require("./ButtonWeb"));
const ErrorMessage_1 = __importDefault(require("../auth/ErrorMessage"));
const ErrorComponentWeb_1 = require("./ErrorComponentWeb");
const react_redux_1 = require("react-redux");
const account_1 = require("../../store/redux/account");
const selectors_1 = require("../../store/redux/selectors");
const react_device_detect_1 = require("react-device-detect");
const ResetPassword = () => {
    const [t] = (0, react_i18next_1.useTranslation)("i18n", { keyPrefix: 'account.reset_password' });
    const [data, setData] = (0, react_1.useState)({ newPassword: '', repeatedPassword: '' });
    const navigation = (0, native_1.useNavigation)();
    const errorMessage = {
        passwordShort: t('errors.password_short'),
        passwordsNotEqual: t('errors.password_not_equal')
    };
    const loginError = (0, react_redux_1.useSelector)(selectors_1.getAccountErrorStatus);
    const [lockButton, setLockButton] = (0, react_1.useState)(false);
    const dispatch = (0, react_redux_1.useDispatch)();
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('token');
    const [isTokenValid, setIsTokenValid] = (0, react_1.useState)(false);
    const [passwordChangeSuccess, setPasswordChangeSuccess] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        (0, authHandlers_1.resetPasswordHandler)({ token: token || '' }, () => {
            setIsTokenValid(true);
        }, () => {
            setIsTokenValid(false);
        });
        return () => {
            dispatch((0, account_1.setAccountError)(null));
        };
    }, []);
    if (loginError && loginError === 'incorrect_token') {
        navigation.navigate('LogIn');
    }
    return ((0, jsx_runtime_1.jsxs)(NavigationWrapperWeb_1.default, { email_verified: true, children: [!passwordChangeSuccess &&
                (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)("span", { className: "title", children: t("title") }) }), isTokenValid && !passwordChangeSuccess &&
                (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)("span", { className: "subtitle", children: t("subtitle") }) }), (0, jsx_runtime_1.jsx)(ErrorMessage_1.default, { errorComponent: ErrorComponentWeb_1.errorComponentWeb, neverDisappear: true }), isTokenValid && !passwordChangeSuccess &&
                (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("div", { style: { marginTop: 30, marginBottom: 30 }, children: [(0, jsx_runtime_1.jsx)(InputWeb_1.default, { value: data, onChange: setData, name: "newPassword", label: t("new_password"), type: "password", showError: true, showPasswordEye: true, placeholder: t("enter_new_password"), validate: helper_1.passwordValidation, errorMessage: errorMessage }), (0, jsx_runtime_1.jsx)(InputWeb_1.default, { value: data, onChange: setData, name: "repeatedPassword", label: t("repeat_password"), type: "password", showError: true, showPasswordEye: true, placeholder: t("enter_repeat_password"), validate: (value) => (0, helper_1.passwordValidation)(value, data.newPassword), errorMessage: errorMessage })] }), (0, jsx_runtime_1.jsxs)("div", { className: "buttons", children: [(0, jsx_runtime_1.jsx)(ButtonWeb_1.default, { type: "Blue", isDisabled: !(0, helper_1.resetPasswordButtonValidation)(data) || lockButton, onClick: () => {
                                        !lockButton && (0, authHandlers_1.resetPasswordHandler)({
                                            password: data.newPassword,
                                            token: token || ''
                                        }, () => {
                                            if (react_device_detect_1.isMobile)
                                                setPasswordChangeSuccess(true);
                                            else {
                                                navigation.navigate('LogIn', { redirect: 'password_reset_success' });
                                                dispatch((0, account_1.setAccountError)(null));
                                            }
                                        }, () => setLockButton(false));
                                        setLockButton(true);
                                    }, fullWidth: true, children: t('send') }), lockButton && (0, jsx_runtime_1.jsx)("span", { className: "basic-spinner" })] })] }), passwordChangeSuccess &&
                (0, jsx_runtime_1.jsxs)("div", { className: "verify-email", children: [(0, jsx_runtime_1.jsx)("p", { className: "font-16-600", children: t('success') }), (0, jsx_runtime_1.jsx)("a", { className: "button-blue button", href: "flyway://", children: t("go_back") })] })] }));
};
exports.default = ResetPassword;
